export default class ImageDTO {
    constructor({ ImageUri, ThumbnailUri, IsCatalogPhoto }) {
        this.uri = ImageUri;
        this.thumbnailUri = ThumbnailUri;
        this.isCatalogPhoto = IsCatalogPhoto;
    }

    toString() {
        return this.thumbnailUri || '';
    }

    toJSON() {
        return this.uri;
    }

    static parse(args) {
        return args ? new ImageDTO(args) : null;
    }

    static parseFromString(src) {
        return src ? new ImageDTO({ ImageUri: src, ThumbnailUri: src }) : null;
    }
}
